import type { KambiOfferingConfiguration } from '@mobi/api-types/kambi'
import { KambiParticipantsData } from '@mobi/api-types/kambi/offering/shapeGamesConfigurations'
import { simpleFetch } from '@mobi/utils/fetch/simpleFetch'

export function getKambiCurrentOfferingConfiguration() {
  return simpleFetch<KambiOfferingConfiguration>(`${window._kc.apiShapeGamesBaseUrl}configurations`)
}

export async function getKambiTeamParticipants(competitionId: number) {
  const data = await simpleFetch<KambiCompetitionParticipantsData>(
    `https://api.icons.fra-hub.workload.shapegamescloud.com/shapegames/play/api/league/${competitionId}/participants`
  )

  return mapParticipants(data)
}

export function getKambiJerseysForEvent(eventId: number) {
  return simpleFetch<KambiJerseysForEventData>(
    `https://api.icons.fra-hub.workload.shapegamescloud.com/rwwawa/api/events/icons?event_id=${eventId}`
  )
}

// =============
// Local Helpers
// =============

const mapParticipants = (data: KambiCompetitionParticipantsData): KambiParticipantsData => ({
  leagueId: Number(data.league_id),

  participants: data.participants.map(participant => ({
    participantId: Number(participant.participant_id),
    participantName: participant.participant_name,

    teamPlayers: participant.team_players?.map(teamPlayer => ({
      playerId: Number(teamPlayer.player_id),
      playerName: teamPlayer.player_name,
    })),
  })),
})

// ===========
// Local Types
// ===========

type KambiCompetitionParticipantsData = {
  league_id: string
  participants: Participant[]
}

type TeamPlayer = {
  player_id: string
  player_name: string
}

type Participant = {
  participant_id: string
  participant_name: string
  team_players?: TeamPlayer[]
}

export type KambiJerseysForEventData = {
  event_participants?: {
    home?: {
      team_player_icons?: { team_players?: KambiPlayerJersey[] }
      id: string
      icon?: { type: string; left_color: string; right_color: string }
    }
    away?: {
      team_player_icons?: { team_players?: KambiPlayerJersey[] }
      id: string
      icon?: { type: string; left_color: string; right_color: string }
    }
  }[]
}

export type KambiPlayerJersey = {
  player_id: string
  jersey_number?: string | null
  jersey_icon?: {
    url?: string
  } | null
  number?: {
    jersey_number?: string | null
    jersey_number_color?: string | null
  } | null
}
